import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Spin } from 'antd'
import GoogleLogin from '../GoogleLogin'
import { on } from '../../utils/sockets'

class Auth extends Component {

  componentDidMount() {
    on('connect', () => {
      const pathname = this.props.location.pathname !== '/' ? this.props.location.pathname : '/model/dispatch'
      this.props.history.push('/')
      this.props.history.push(pathname)
    })
  }

  render() {
    if (this.props.authenticated) {
      if (!this.props.unauthorized) {
        return this.props.children
      }

      return (
        <Fragment>
          {this.props.unauthorized && <GoogleLogin />}
          <Spin>
            {this.props.children}
          </Spin>
        </Fragment>
      )
    } else {
      return <GoogleLogin />
    }
  }

}

const mapStateToProps = state => ({
  authenticated: Boolean(state.auth.user),
  unauthorized: state.auth.unauthorized
})

export default withRouter(connect(mapStateToProps)(Auth))



// WEBPACK FOOTER //
// ./src/containers/Auth/index.js